(function() {
    'use strict';
    /*
     * Copyright (c) 2014-2019 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('campaignMessages', campaignMessages);

    function campaignMessages() {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                /**
                 * If provided, the campaign is within the scope of this clinic; otherwise it is an IHH campaign.
                 */
                clinic: '=',

                /**
                 * If provided, the ID of the therapist that should be initially set for new messages.
                 */
                therapistId: '=',

                /**
                 * If provided, an initialized config for choosing therapists to assign to the template; if not provided, no therapists can be assigned.
                 */
                therapistConfig: '=',

                /**
                 * An object with methods to query, create, read, update, and delete campaign resource materials.
                 */
                messagesCrud: '=',

                episodeModel: '=',

                /**
                 * Indicates whether the message are read only.
                 */
                isReadOnly: '='
            },
            controller: 'CampaignMessagesCtrl',
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'campaign-messages/campaign-messages.tpl.html'
        };
    }
})();
